<template>
    <button 
        class="btn"
        :disabled="isDisabled"
        @click="$emit('click', $event)">
        <template v-if="state === 'success'">
            <span class="state-content">
                <slot v-if="$slots.success" name="success" />
                <slot v-else />
                
                <template v-if="bootstrap3">
                    <i class="glyphicon glyphicon-ok"></i>
                </template>
                <template v-else>
                    <i class="ri-check-line"></i>
                </template>
            </span>
        </template>
        <template v-else-if="state === 'error'">
            <span class="state-content">
                <slot v-if="$slots.error" name="error" />
                <slot v-else />
                
                <template v-if="bootstrap3">
                    <i class="glyphicon glyphicon-remove-circle"></i>
                </template>
                <template v-else>
                    <i class="ri-close-line"></i>
                </template>
            </span>
        </template>
        <template v-else-if="state === 'loading'">
            <span class="state-content">
                <slot v-if="$slots.loading" name="loading" />
                <slot v-else />
                
                <template v-if="bootstrap3">
                    <i class='glyphicon glyphicon-refresh spinner-icon'></i>
                </template>
                <template v-else>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </template>
            </span>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </button>
</template>

<script>
export default {
    emits: ['click'],
    data() {
        return {
            state: 'idle',
            bootstrap3: window.wisenetwork?.bootstrap3 || false,
        }
    },
    computed: {
        isDisabled() {
            return ['success', 'loading', 'disabled', 'error'].includes(this.state)
        },
        spinnerImg() {
            return window.wisenetwork.ASSETS_SRC + '/assets/images/spinner_96x96.gif'
        },
    },
    methods: {
        setState(value) {
            if (!['idle', 'success', 'loading', 'disabled', 'error'].includes(value)) return false;

            this.state = value

            return true;
        },
        handlePromise(promise, ms = 1500) {
            this.state = 'loading'

            promise
            .then(({ data }) => {
                if (data && typeof data.success !== 'undefined') {
                    this.state = data.success ? 'success' : 'error'
                } else {
                    this.state = 'success'
                }
            },
            () => {
                this.state = 'error'
            })
            .finally(() => {
                // ms can be set null meaning that setState method
                // is called manually afterwards
                if (ms !== null) {
                    setTimeout(() => {
                        this.state = 'idle'
                    }, ms)
                }
            })

            return promise
        },
    },
}
</script>

<style scoped>
.state-content {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 7px;
    height: 100%;
}

.spinner-icon {
    display: inline-block;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>